import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { PaginationBar } from 'mailup-web-components'

import { fetchResultsCallback } from 'Pages/GroupsList/recoil/callbacks/callbacks'
import { paginationState } from 'Pages/GroupsList/recoil/state/state'

const Pager: FC = () => {
  const intl = useIntl()

  const { pageNumber, pageSize, totalItems } = useRecoilValue(paginationState)

  const fetchResults = useRecoilCallback(fetchResultsCallback, [])

  const handleChangePage = (pageNumber: number): void => {
    void fetchResults(
      {
        pageNumber,
      },
      {},
    )
  }

  const handleChangePageSize = (pageSize: number): void => {
    void fetchResults(
      {
        pageNumber: 1,
        pageSize,
      },
      {},
    )
  }

  return (
    <PaginationBar
      margin="0"
      minPageSize={5}
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      handleChangePage={handleChangePage}
      handleChangePageSize={handleChangePageSize}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' }),
      }}
      data-mu-test="results-list__pagination"
      formatValues={intl.formatNumber}
    />
  )
}

export default Pager
